import { render } from "./SubmitModal.vue?vue&type=template&id=63496e68&scoped=true"
import script from "./SubmitModal.vue?vue&type=script&lang=js"
export * from "./SubmitModal.vue?vue&type=script&lang=js"

import "./SubmitModal.vue?vue&type=style&index=0&id=63496e68&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63496e68"]])

export default __exports__